module.exports = __webpack_public_path__ + "static/img/images.63599af4.png";